import createAxios from './api'

const PATH = 'evroRefs'

export default {

  async createEvroRef(req, timeOut) {
    const axios = await createAxios(true, timeOut)
    const resp = await axios.post(`${PATH}`, req)

    return resp.data
  },

  async listEvroRefs(userId, q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}`, {
      params: {
        userId,
        q: q?.toString() || '',
        ...pageRequest
      }
    })

    return resp.data
  },

  async updateEvroRef(id, dto) {
    const axios = await createAxios()
    await axios.put(`${PATH}/${id}`, dto)
  },

  async getEvroRef(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}`)

    return resp.data
  },

  async deleteEvroRef(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${id}`)
  }

}
